<template>
  <b-card no-body >
    <b-card-header>
      <b-card-title class="mb-50"><h4>کاربران
        </h4>  </b-card-title>
    </b-card-header>
    <b-card-body>
      <div v-if="loading">
        <b-skeleton width="100%" height="280px" />
      </div>
      <vue-apex-charts
        v-else
        type="bar"
        height="270"
        :options="columnChart.chartOptions"
        :series="columnChart.series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardHeader,
  BCardTitle,
  BSkeleton,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import { $themeColors } from '@themeConfig';

import qs from "qs";

export default {
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    VueApexCharts,
    BCardTitle,
    BSkeleton,
  },
  data() {
    return {
      columnChart: {
        series: [
          {
            name: "کاربران ",
            data: [],
          },
          {
            name: "کاربران یونیک",
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            stacked: false,
            toolbar: {
              show: false,
            },
          },
          colors: [$themeColors.primary, $themeColors.info], 
          plotOptions: {
            bar: {
              columnWidth: "30%",
              borderRadius: 3,
            },
          },
          dataLabels: {
            enabled: true,
          },
          legend: {
            show: true,
            position: "top",
            fontSize: "14px",
            fontFamily: "Montserrat",
            horizontalAlign: "left",
          },
          stroke: {
            show: false,
            colors: ["transparent"],
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
            padding: {
              bottom: -35, 
            },
          },
          xaxis: {
            categories: [ ],
          },
          yaxis: {
            opposite: true,
          },
          fill: {
            opacity: 1,
          },
        },
      },
      users: {},
      loading: false,
    };
  },
  created() {
    this.getProgress();
  },
  methods: {
    async getProgress() {
      this.loading = true;
      try {
        const params = {
          filters: {
            semester_id: this.$route.params.id,
          },
        };
        const { data } = await this.$http.get(`panel/semester/students`, {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.users = data.data[0][0];
        this.columnChart.series[0].data[0]= this.users.all;
        this.columnChart.series[1].data[0] = this.users.unique;
        this.columnChart.chartOptions.xaxis.categories[0] =
          this.users.semester.name;
      } catch (e) {}
      this.loading = false;
    },
  },
};
</script>
